import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=23016e8d&scoped=true"
import script from "./videoPlay.vue?vue&type=script&lang=js"
export * from "./videoPlay.vue?vue&type=script&lang=js"
import style0 from "./videoPlay.vue?vue&type=style&index=0&id=23016e8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23016e8d",
  null
  
)

export default component.exports